const config = {};

config.auto_relogin = true; //if token expired than request new key by calling login silent
config.auto_refresh = false; //if refresh token in moment when system is down - auto logout
config.default_hostname = "stream.racegraphics.eu"; //localhost
//config.default_hostname = "localhost";
config.default_port = "3030";
config.default_page = "/events_list";
config.client_download_url =
  "https://stream.racegraphics.eu/downloads/orbitclient/setup.exe";
config.client_manual_url =
  "https://stream.racegraphics.eu/downloads/orbitclient/OrbitStreamingClientMANUAL.pdf";
config.client_logos_manual_url =
  "https://stream.racegraphics.eu/downloads/orbitclient/CarsBikesKartingsMAKEorbits.pdf";

export default config;
